// extracted by mini-css-extract-plugin
export var animationContainer = "_gm-0";
export var footer = "_gm-1";
export var gray = "_gm-2";
export var lineItem = "_gm-3";
export var lineItemImage = "_gm-4";
export var lineItemInfo = "_gm-5";
export var lineItemText = "_gm-6";
export var lineItems = "_gm-7";
export var modalContent = "_gm-8";
export var options = "_gm-9";
export var orderName = "_gm-a";
export var refundAmount = "_gm-b";